import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    "Trusted and Verified Carbon Credit Programs",
    "Expert Guidance for Net Zero Goals",
    "Comprehensive Environmental Sustainability Strategies",
    "Transparent and Measurable Impact Reporting",
    "Customized Climate Solutions for Your Industry",
    "Commitment to Global Sustainability Standards"
  ];

  return (
    <section id="why-us" className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div 
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-primary font-bold tracking-wider uppercase mb-2">Why Choose CoxCred</h2>
            <h3 className="text-4xl font-extrabold text-teal-950 mb-6 leading-tight">
              Your Partner in Climate Responsibility
            </h3>
            <p className="text-lg text-gray-600 mb-8">
              We go beyond consulting; we partner with you to implement real, measurable changes that benefit both your business and the planet. Our expertise ensures your sustainability initiatives are effective and credible.
            </p>
            
            <ul className="space-y-4">
              {reasons.map((reason, index) => (
                <motion.li 
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.5 }}
                  className="flex items-start"
                >
                  <CheckCircle2 className="w-6 h-6 text-accent mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700 font-medium">{reason}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="rounded-3xl overflow-hidden shadow-2xl relative">
              <img 
                src="https://images.unsplash.com/photo-1532601224476-15c79f2f7a51?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                alt="Green energy solar panels" 
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-teal-900/20 mix-blend-multiply"></div>
            </div>
            
            {/* Decoration */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-accent/20 rounded-full blur-xl -z-10"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-primary/20 rounded-full blur-xl -z-10"></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
